import { FC } from 'react';

import { theme } from 'antd';
import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const GDPlatinumTrustIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 85, height = 32, ...rest }) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentThemeColor = token.GDPlatinumColor;

  return (
    <svg width={width} height={height} viewBox="0 0 85 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M40.9934 18.669H37.0002V16.6186H47.218V18.669H43.224V29.2083H40.9934V18.669Z" fill="#CF202F" />
      <path
        d="M47.2909 19.7118H49.4672V21.8524C50.0607 20.4317 51.1582 19.4601 52.8309 19.5324V21.8345H52.7047C50.7981 21.8345 49.4672 23.0752 49.4672 25.5932V29.2083H47.2909V19.7118Z"
        fill="#CF202F"
      />
      <path
        d="M53.8924 25.7552V19.7118H56.0692V25.1076C56.0692 26.5822 56.8067 27.4097 58.102 27.4097C59.3609 27.4097 60.2424 26.5463 60.2424 25.0717V19.7118H62.4374V29.2084H60.2424V27.7332C59.6307 28.6325 58.7497 29.4063 57.2743 29.4063C55.134 29.4063 53.8924 27.967 53.8924 25.7552Z"
        fill="#CF202F"
      />
      <path
        d="M63.6616 27.967L64.6329 26.4925C65.6757 27.2657 66.7733 27.6615 67.7445 27.6615C68.6798 27.6615 69.2199 27.2657 69.2199 26.6366V26.6001C69.2199 25.8629 68.2122 25.6111 67.0973 25.2697C65.6935 24.8738 64.1293 24.2981 64.1293 22.4821V22.4456C64.1293 20.6476 65.622 19.5504 67.5107 19.5504C68.6976 19.5504 69.9929 19.9641 71.0002 20.629L70.1374 22.1759C69.2199 21.6186 68.2482 21.2766 67.4569 21.2766C66.611 21.2766 66.1256 21.6725 66.1256 22.2118V22.2483C66.1256 22.9497 67.1511 23.2373 68.2664 23.5967C69.6515 24.0284 71.2162 24.658 71.2162 26.3663V26.4028C71.2162 28.3988 69.6693 29.3883 67.6907 29.3883C66.3412 29.3883 64.8485 28.9022 63.6616 27.967Z"
        fill="#CF202F"
      />
      <path
        d="M72.9983 26.5822V21.5828H71.7932V19.7118H72.9983V17.1042H75.1747V19.7118H77.7289V21.5828H75.1747V26.2408C75.1747 27.0862 75.6063 27.4276 76.3438 27.4276C76.8301 27.4276 77.2613 27.32 77.6929 27.1042V28.8843C77.1533 29.1904 76.5594 29.3698 75.7326 29.3698C74.1314 29.3698 72.9983 28.6684 72.9983 26.5822Z"
        fill="#CF202F"
      />
      <path
        d="M39.0912 9.69388C39.826 9.69388 40.2839 9.28299 40.2839 8.70659V8.69099C40.2839 8.04396 39.8176 7.70432 39.0912 7.70432H37.9622V9.69388H39.0912ZM36.9915 6.82001H39.1699C40.4657 6.82001 41.2707 7.55441 41.2707 8.66725V8.68348C41.2707 9.92246 40.2754 10.57 39.0601 10.57H37.9622V12.3461H36.9915V6.82001Z"
        fill={currentThemeColor}
      />
      <path d="M43.3342 6.82001H44.3046V11.4618H47.2104V12.3461H43.3342V6.82001Z" fill={currentThemeColor} />
      <path
        d="M52.1619 10.1516L51.2071 7.94099L50.2594 10.1516H52.1619ZM50.7728 6.78068H51.6729L54.1045 12.3461H53.0781L52.5171 11.0116H49.9042L49.3357 12.3461H48.3408L50.7728 6.78068Z"
        fill={currentThemeColor}
      />
      <path
        d="M56.768 7.71992H55.0153V6.82001H59.5001V7.71992H57.7469V12.3461H56.768V7.71992Z"
        fill={currentThemeColor}
      />
      <path d="M61.6489 6.82001H62.6201V12.3461H61.6489V6.82001Z" fill={currentThemeColor} />
      <path
        d="M65.1641 6.82001H66.0643L69.0248 10.6406V6.82001H69.9796V12.3461H69.1666L66.119 8.41494V12.3461H65.1641V6.82001Z"
        fill={currentThemeColor}
      />
      <path
        d="M72.3831 10.0012V6.82001H73.3535V9.96183C73.3535 10.9884 73.8825 11.533 74.7515 11.533C75.6121 11.533 76.1411 11.0197 76.1411 10.0012V6.82001H77.1119V9.95432C77.1119 11.6042 76.1807 12.4329 74.736 12.4329C73.2984 12.4329 72.3831 11.6042 72.3831 10.0012Z"
        fill={currentThemeColor}
      />
      <path
        d="M79.515 6.82001H80.5494L82.2306 9.43285L83.9122 6.82001H84.9466V12.3461H83.9757V8.38312L82.2306 10.9884H82.199L80.4698 8.39876V12.3461H79.515V6.82001Z"
        fill={currentThemeColor}
      />
      <path
        d="M25.819 8.58493C25.819 10.4541 25.6513 13.3292 24.8567 16.4096C23.9682 19.8539 22.5233 22.7877 20.5629 25.1288C18.8036 27.2286 16.5791 28.9072 13.9492 30.1173L13.7295 30.2181L13.5099 30.1173C10.8799 28.9072 8.6553 27.2286 6.89611 25.1288C4.93578 22.7877 3.49087 19.8539 2.60227 16.4096C1.80774 13.3285 1.64007 10.4541 1.64007 8.58493V8.17355L2.03916 8.07453C5.61212 7.18675 8.76296 5.47178 10.7773 4.1892C11.6794 3.61506 12.5656 2.9976 13.4109 2.35471L13.7295 2.11218L14.0482 2.35471C14.8935 2.9976 15.7796 3.61506 16.6818 4.1892C18.696 5.47178 21.847 7.18675 25.4199 8.07453L25.819 8.17355V8.58493ZM27.4086 6.8112C23.4923 6.17644 19.9261 4.31107 17.5623 2.80644C15.8142 1.69342 14.4789 0.632977 13.7295 0C12.9802 0.632977 11.6448 1.69342 9.89667 2.80644C7.53284 4.31107 3.96668 6.17644 0.0503314 6.8112C-0.0461739 8.42164 -0.122853 12.4097 1.01449 16.8191C2.9234 24.2194 7.19999 29.3248 13.7295 32C20.259 29.3248 24.5355 24.2194 26.4445 16.8191C27.5818 12.4104 27.5052 8.42231 27.4086 6.8112Z"
        fill={currentThemeColor}
      />
      <path
        d="M13.7294 3.28915L13.0107 3.80209C12.4437 4.20653 11.8601 4.60004 11.2758 4.972C9.49788 6.10413 6.70065 7.6596 3.47148 8.6412L2.55586 8.91946L2.5948 9.87546C2.68446 12.0731 2.98936 14.1935 3.50104 16.1778C4.35488 19.4872 5.73645 22.2982 7.60765 24.5329C9.11137 26.3277 10.9816 27.8036 13.1665 28.9195L13.7294 29.2072V3.28915Z"
        fill="#AA1E2E"
      />
      <path
        d="M13.7294 3.28915L14.4483 3.80209C15.0153 4.20653 15.5988 4.60004 16.1832 4.972C17.9611 6.10413 20.7583 7.6596 23.9875 8.6412L24.9032 8.91946L24.8642 9.87546C24.7745 12.0731 24.4696 14.1935 23.9579 16.1778C23.1041 19.4872 21.7225 22.2982 19.8513 24.5329C18.3476 26.3277 16.4773 27.8036 14.2925 28.9195L13.7294 29.2072V3.28915Z"
        fill="#CF202F"
      />
      <path d="M78.6322 28.2141H78.2526V27.9612H79.2856V28.2141H78.9065V29.2083H78.6322V28.2141Z" fill="#CF202F" />
      <path
        d="M79.4937 27.9612H79.7893L80.1173 28.4884L80.4449 27.9612H80.741V29.2083H80.468V28.3941L80.1173 28.9271H80.1098L79.7626 28.3999V29.2083H79.4937V27.9612Z"
        fill="#CF202F"
      />
    </svg>
  );
};

export default GDPlatinumTrustIcon;
